import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const ArrowRightIcon = createIcon({
	viewBox: '0 0 14 14',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 6.7504A.8804.8804 0 0 1 .8804 5.87h11.7392a.8804.8804 0 0 1 0 1.7609H.8804A.8804.8804 0 0 1 0 6.7504Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.1275 13.2421a.8804.8804 0 0 1 0-1.2451l5.247-5.247-5.247-5.247A.8804.8804 0 0 1 7.3726.2579l5.8696 5.8695a.8805.8805 0 0 1 0 1.2452L7.3726 13.242a.8803.8803 0 0 1-1.2451 0Z"
				fill="currentColor"
			/>
		</>
	),
});
